import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation, 
  ViewChild,
  ChangeDetectorRef} from '@angular/core';


import {
  CompactType,
  DisplayGrid,
  Draggable,
  GridsterConfig,
  GridsterItem,
  GridType,
  PushDirections,
  GridsterItemComponentInterface,
  Resizable
} from 'angular-gridster2';
import { EveReportingWidgetType } from '../../components/widgets/widget.component';

import { ActivatedRoute, Router } from '@angular/router';
import { map, of, switchMap, tap, Observable, BehaviorSubject, startWith, interval, ReplaySubject } from 'rxjs';
import { ControlWidgetService } from '../../services/ControlWidgetService.service';
import { NgForm } from '@angular/forms';
import { IGraphQlService } from '../../services/GraphQl/IGraphQL.service';
import { GlobalFiltersOptionalService } from '../../services/DataSourceServices/GlobalFiltersOptionalService.service';




interface Safe extends GridsterConfig {
  draggable: Draggable;
  resizable: Resizable;
  pushDirections: PushDirections;
}



export interface CustomGridsterItem {
  x: number;
  y: number;
  rows: number;
  cols: number;
  backgroundColour: any;
  widget?: any;
}

@Component({
  selector: 'customisablereports',
  templateUrl: './customisablereports.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./customisablereports.component.css']
  
})
export class CustomisableReportsComponent implements OnInit {
  
  options!: Safe;
  dashboard!: Array<CustomGridsterItem>;
  showFiller = false;
  itemChange(
    item: CustomGridsterItem
  ): void {
    
  }

  @ViewChild(NgForm) form!: NgForm;

  widgetTypes = EveReportingWidgetType;

  isPanelEditable = false;

  secondMenuOpen = false;

  editingDashboard?: Array<CustomGridsterItem> = null;

  selectedItem: CustomGridsterItem | null = null;
  editingItem: CustomGridsterItem | null = null;

  reportId!: number;
  isLoading: boolean = false;

  constructor(
    public graphQlService: IGraphQlService,
    private route: ActivatedRoute,
    public controlWidgetService: ControlWidgetService,
    public globalFiltersOptionalService: GlobalFiltersOptionalService,
    private ref: ChangeDetectorRef
  ) {
  }

  startDate: ReplaySubject<Date> = new ReplaySubject<Date>();
  endDate: ReplaySubject<Date> = new ReplaySubject<Date>();


  minStartDate: Observable<Date> = interval(60000).pipe(
    startWith(null),
    map(() => {
      const minStartDate = new Date();
      minStartDate.setMonth(minStartDate.getMonth() - 3);
      if (minStartDate > new Date('2022-07-19')) {
        return minStartDate;
      }
      else {
        return new Date('2022-07-19');
      }
    })
  );

  ngOnInit(): void {


    this.isLoading = false;
    this.route.params.pipe(
      tap(() => {
        this.isLoading = true;
        this.ref.markForCheck();
      }),
      switchMap(params => {
        this.reportId = params['id'];

        return this.reportId == null ?
          of({ name: "", data: [] }) :
          this.graphQlService.executeGraphQl(`{ \
            eveCustomisableReport(reportId: ${this.reportId}){ \
                    name, \
                    data\
                  } \
            }\
          `).pipe(
            map(response => ({ name: response.data.eveCustomisableReport?.name, data: JSON.parse(response.data.eveCustomisableReport?.data ?? "[]") }))
          )
      }),
      tap(() => {
        this.isLoading = false
        this.ref.markForCheck();
      }),
    ).subscribe(params => {
      this.isLoading = false;
      this.dashboard = params.data ?? [];
    });

    //alert("onINIT");
    this.options = {
      gridType: GridType.Fit,
      compactType: CompactType.None,
      itemChangeCallback: this.itemChange.bind(this),
      margin: 0,
      outerMargin: true,
      outerMarginTop: null,
      outerMarginRight: null,
      outerMarginBottom: null,
      outerMarginLeft: null,
      useTransformPositioning: true,
      mobileBreakpoint: 640,
      useBodyForBreakpoint: false,
      minCols: 200,
      maxCols: 200,
      minRows: 200,
      maxRows: 200,
      maxItemCols: 9999999999999999999999999,
      minItemCols: 1,
      maxItemRows: 99999999999999,
      minItemRows: 1,
      maxItemArea: 999999999999999, 
      minItemArea: 1,
      defaultItemCols: 1,
      defaultItemRows: 1,
      fixedColWidth: 105,
      fixedRowHeight: 105,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 0,
      scrollSpeed: 100,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      enableOccupiedCellDrop: false,
      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      ignoreMarginInRow: false,
      draggable: {
        enabled: false,
      },
      enableBoundaryControl: true,
      resizable: {
        enabled: false
      },
      swap: false,
      pushItems: true,
      disablePushOnDrag: false,
      disablePushOnResize: false,
      pushDirections: { north: true, east: true, south: true, west: true },
      pushResizeItems: false,
      displayGrid: DisplayGrid.OnDragAndResize,
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: false
    };
  }

 
 

  changedOptions(): void {
    if (this.options.api && this.options.api.optionsChanged) {
      this.options.api.optionsChanged();      
    }
  }

  removeItem($event: MouseEvent | TouchEvent, item: any): void {
    if (confirm("Are you sure you want to remove the current item?")) {
      $event.preventDefault();
      $event.stopPropagation();
      this.editingDashboard.splice(this.editingDashboard.indexOf(item), 1);
    } 
  }

  addItem(): void {
    this.editingDashboard.push({
      x: 0, y: 0, cols: 10, rows: 10, backgroundColour: '#FFFFFF', widget: {
        widgetType: null
      }
    });
  }

  editItem($event: MouseEvent | TouchEvent, item: any): void {
    $event.preventDefault();
    $event.stopPropagation();

    this.selectedItem = item;
    this.editingItem = JSON.parse(JSON.stringify(item));



  }

  cancelItem() {
    this.editingItem = null;
    this.selectedItem = null;
  }

  secondMenuOpener() {
    if (this.secondMenuOpen == true) this.secondMenuOpen = false
    else this.secondMenuOpen = true;
  }

  okayItem() {


    if (!this.form.valid) {
      alert("wrong");
      return
    } 

    Object.assign(this.selectedItem, this.editingItem);
    this.editingItem = null;
    this.selectedItem = null;
  }

  makePageEditbale() {
    this.isPanelEditable = true;
    this.options.draggable.enabled = true;
    this.options.resizable.enabled = true;
    this.changedOptions();

    this.editingDashboard = JSON.parse(JSON.stringify(this.dashboard));

  }

  makePageUneditbale() {
    this.isPanelEditable = false;
    this.options.draggable.enabled = false;
    this.options.resizable.enabled = false;
    this.changedOptions();
    this.selectedItem = null;
    this.editingDashboard = null;
  }



  bckgrdColourButton(colour: any) {
    //this.widgetInEditing.map(a => a.backgroundColour = colour);
    //console.log(JSON.stringify(this.widgetInEditing));

    //var id = this.widgetInEditing.map(b => b.ID).toString();

    //console.log(id);
    //const element = document.getElementById(id);
   // if (element != null) element.style.backgroundColor = colour;
    //console.log(this.widgetInEditing);
    //console.log(this.dashboard.filter(b => b.ID == id));
    //element.style.backgroundColor = 'red';
    
    if (this.selectedItem != null) this.selectedItem.backgroundColour = colour;
  }

  save() {
    if (this.reportId == null) {

      this.saveAs();
      return
    }
    if (confirm("Are you sure you would like to save your changes?") == false) return;

    this.dashboard = this.editingDashboard;
    this.makePageUneditbale();

    const data = JSON.stringify(JSON.stringify(this.dashboard));
    this.graphQlService.executeGraphQl(`\
          mutation{\
            updateReport(\
              report: {\
                iD:${this.reportId}\
                data: ${data}  \
              }\
            ) \
            { \
              name\
              iD\
            }\
          }\ `
    ).subscribe(() => {
      alert("save");
    })   
  }

  saveAs() {
    if (confirm("Are you sure you would like to save your changes?") == false) return;

    this.dashboard = this.editingDashboard;
    this.makePageUneditbale();

    const data = JSON.stringify(JSON.stringify(this.dashboard));

    //get name for report
    const name = prompt("Name");
    this.graphQlService.executeGraphQl(`\
          mutation{\
            createReport(\
              report: {\
                iD:0\
                name: "${name}" \
                data: ${data}  \
                companyId: 0\
                createDate: \"2023-11-12T00:00:00+00:00\"\
              }\
            ) \
            { \
              name\
              iD\
            }\
          }\ `
    ).subscribe(response => {
      //get id out reponse and set this.reportId
      this.reportId = response.data.createReport.iD;

      window.history.replaceState({}, '', `/CustomisableReports/${this.reportId}`);
      alert("create done");
    })
  }

  cancel() {
    if (confirm("Are you sure you want to cancel? You will lose any unsaved changes.")) {
   
      this.makePageUneditbale();
      this.editingItem = null;
      this.selectedItem = null;
    }
  }

  fullScreenMode() {
    alert("Will activate full screen mode one day");
  }

  onSelectCompany(company: any) {
    this.globalFiltersOptionalService.SetCompany(company);

  }

}


